import { jsxs, jsx } from 'react/jsx-runtime';
import { Button } from '@design-system/button';
import { CheckboxField } from '@design-system/checkbox-field';
import { ErrorMessage } from '@design-system/error-message';
import { Typography } from '@design-system/typography';
import classNames from 'classnames';
import { useState, useEffect } from 'react';

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') {
    return;
  }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".checkbox-group-module_link__h4OTe {\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n.checkbox-group-module_label__tXf6q {\n  color: var(--phx-textColor, #101010);\n}\n\n.checkbox-group-module_errorMessage__mKXM3 {\n  margin: 0.5rem 0;\n}\n\n.checkbox-group-module_errorMessage__mKXM3.cds-error-icon {\n  margin: 0px;\n  width: var(0.75rem);\n  height: var(0.75rem);\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImNoZWNrYm94LWdyb3VwLm1vZHVsZS5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0UsMEJBQTBCO0VBQzFCLGVBQWU7QUFDakI7O0FBRUE7RUFDRSxvQ0FBb0M7QUFDdEM7O0FBRUE7RUFDRSxnQkFBZ0I7QUFDbEI7O0FBQ0E7RUFDRSxXQUFXO0VBQ1gsbUJBQW1CO0VBQ25CLG9CQUFvQjtBQUN0QiIsImZpbGUiOiJjaGVja2JveC1ncm91cC5tb2R1bGUuc2NzcyIsInNvdXJjZXNDb250ZW50IjpbIi5saW5rIHtcbiAgdGV4dC1kZWNvcmF0aW9uOiB1bmRlcmxpbmU7XG4gIGN1cnNvcjogcG9pbnRlcjtcbn1cblxuLmxhYmVsIHtcbiAgY29sb3I6IHZhcigtLXBoeC10ZXh0Q29sb3IsICMxMDEwMTApO1xufVxuXG4uZXJyb3JNZXNzYWdlIHtcbiAgbWFyZ2luOiAwLjVyZW0gMDtcbn1cbi5lcnJvck1lc3NhZ2U6Z2xvYmFsKC5jZHMtZXJyb3ItaWNvbikge1xuICBtYXJnaW46IDBweDtcbiAgd2lkdGg6IHZhcigwLjc1cmVtKTtcbiAgaGVpZ2h0OiB2YXIoMC43NXJlbSk7XG59Il19 */";
var styles = {"link":"checkbox-group-module_link__h4OTe","label":"checkbox-group-module_label__tXf6q","errorMessage":"checkbox-group-module_errorMessage__mKXM3"};
styleInject(css_248z);

const CheckboxGroup = ({ name, onChange, classes, defaultValue, options = [], errorMessage, }) => {
    const [values, setValues] = useState(defaultValue || []);
    useEffect(() => {
        onChange({ name, value: values });
    }, [values]);
    const handleCheckbox = (e) => {
        if (e.target.checked) {
            setValues((prev) => [...prev, e.target.value]);
        }
        else {
            setValues(values.filter((item) => item !== e.target.value));
        }
    };
    const createCheckBoxLabel = (labels) => labels.map((item) => {
        const key = item.value.replace(/\s/g, '_');
        const onClickFunction = (e) => {
            e.preventDefault();
            item.onClick();
        };
        return typeof item.onClick === 'function' ? (jsx(Button, Object.assign({ variant: "subtle", role: "button", className: styles.link, onClick: onClickFunction, tabIndex: 0 }, { children: jsx(Typography, { variant: "body", tag: "span", size: "m", weight: "bold", className: styles.label, content: item.value }) }), key)) : (jsx(Typography, { variant: "body", tag: "span", size: "m", className: styles.label, content: item.value }, key));
    });
    return (jsxs("div", Object.assign({ className: classNames(classes === null || classes === void 0 ? void 0 : classes.container, 'checkbox-group__container'), "data-testid": "checkbox-group-container" }, { children: [options.map((item) => (jsx(CheckboxField, { isDisabled: item.isDisabled, id: `${name}-${item.key}`, name: name, "data-testid": `${name}-${item.key}`, label: item.labels ? createCheckBoxLabel(item.labels) : undefined, value: item.key, onChange: handleCheckbox, isHidden: item.hideCheckbox, checked: values.includes(item.key) }, `${name}-${item.key}`))), errorMessage ? (jsx(ErrorMessage, { className: styles.errorMessage, message: errorMessage })) : null] })));
};

export { CheckboxGroup };
